import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import type { InventoryResource } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';
import { DynamoDbBillingModes } from '@/data/inventory/data';

export const DynamoDBPropertiesSection = ({
  resource,
}: {
  resource: InventoryResource;
}) => {
  const properties = resource.resourceProperties?.awsDynamoDb;

  return (
    <Table
      className='w-full'
      sx={{
        '& .props-col': {
          verticalAlign: 'top',
          width: '225px',
          paddingLeft: '40px',
        },
      }}
    >
      <TableBody>
        {properties?.billingMode &&
          DynamoDbBillingModes[properties.billingMode]?.name && (
            <TableRow>
              <TableCell
                className='props-col'
                sx={{
                  borderTop: '1px solid var(--mui-palette-TableCell-border)',
                }}
              >
                Billing mode
              </TableCell>
              <TableCell
                sx={{
                  borderTop: '1px solid var(--mui-palette-TableCell-border)',
                }}
              >
                {DynamoDbBillingModes[properties.billingMode].name}
              </TableCell>
            </TableRow>
          )}
        {typeof properties?.readCapacityUnits === 'number' && (
          <TableRow>
            <TableCell className='props-col'>Read capacity units</TableCell>
            <TableCell>{properties.readCapacityUnits}</TableCell>
          </TableRow>
        )}
        {typeof properties?.writeCapacityUnits === 'number' && (
          <TableRow>
            <TableCell className='props-col'>Write capacity units</TableCell>
            <TableCell>{properties.writeCapacityUnits}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export const DynamoDBBackupConfigurationSection = ({
  resource,
}: {
  resource: InventoryResource;
}) => {
  const dal = useDAL();
  const { data: configResponse } =
    dal.inventory.backupConfiguration.dynamodb.get(resource.id);

  if (!configResponse) {
    return null;
  }

  return (
    <Table
      className='w-full'
      sx={{
        '& .props-col': {
          verticalAlign: 'top',
          width: '225px',
          paddingLeft: '40px',
        },
      }}
    >
      <TableBody>
        <TableRow>
          <TableCell className='props-col'>Autoscale</TableCell>
          <TableCell>
            {configResponse.isAutoscaleEnabled ? 'Enabled' : 'Disabled'}
          </TableCell>
        </TableRow>
        {typeof configResponse.maxReadCapacityUnits === 'number' && (
          <TableRow>
            <TableCell className='props-col'>
              Maximum read capacity units
            </TableCell>
            <TableCell>{configResponse.maxReadCapacityUnits}</TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell className='props-col'>
            Read capacity units required for backup
          </TableCell>
          <TableCell>{configResponse.readCapacityUnitsRequired}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
